import React from 'react'

const STYLES = {
  pending:    'bg-slate-100 text-slate-700',
  processing: 'bg-amber-100 text-amber-800',
  completed:  'bg-emerald-100 text-emerald-800',
  failed:     'bg-rose-100 text-rose-700',
}

const LABELS = {
  pending:    'Pending',
  processing: 'Processing…',
  completed:  'Ready',
  failed:     'Failed',
}

export default function ArtifactStatusBadge({ status }) {
  const className = STYLES[status] || STYLES.pending
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${className}`}>
      {LABELS[status] || status}
    </span>
  )
}
